import React from 'react'



const Super=() =>{
  return (
    <div>
      <>
     <div id='Footer'>
      <div className='row'>
        <div className='col-md-12'>

       
<footer className="text-center text-lg-start bg-light text-muted">
  
  <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
    
    <div className=" d-none d-lg-block">
      <span>Get connected with us on social networks:</span>
    </div>
   
    <div>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-google"></i>
      </a>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-linkedin"></i>
      </a>
      <a href="/" className="me-4 text-reset">
        <i className="fab fa-github"></i>
      </a>
    </div>
   
  </section>
 
  <section className="">
    <div className="container text-center text-md-start mt-5">
     
      <div className="row mt-3">
       
        <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
          
          <h6 className="text-uppercase fw-bold mb-4">
            <i className="fas fa-gem me-3"></i>Company name
          </h6>
          <p>
          FundGuard has been launched by Ram Kumar Sahu as a flagship company to offer Insurance & Financial Products & related Services to individuals and businesses within Delhi NCR.
          </p>
        </div>
        
       
        
        <div id='foo' className="col-md-3 col-lg-2  col-xl-2 mx-auto mb-3">
         
          <h6 className="text-uppercase fw-bold mb-4">
        
          </h6>
          <p>
            <a href="/Licinfo" className="text-reset">Licinfo</a>
          </p>
          <p>
            <a href="Services" className="text-reset">Services</a>
          </p>
          <p>
            <a href="/" className="text-reset">Home</a>
          </p>
          <p>
            <a href="About" className="text-reset">About</a>
            

          </p>
        </div>
       
        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
        
          <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
          <p><i className="fas fa-home me-3"></i>2/25 RoopNagar, Delhi. 110007</p>
          <p>
            <i className="fas fa-envelope me-3"></i>
            rks.fundguard@gmail.com
          </p>
          <p><i className="fas fa-phone me-3"></i>+91 880-220-2259</p>

        </div>
       
      </div>
     
    </div>
  </section>
  

  
  <div className="text-center p-4" >
  All Rights Reserved 2019 ©
    
    
  </div>
  <div className="text-left p-1" >
  Designed by: A spider technology
    
    
  </div>
 
</footer>
</div>

</div>

</div>

      </>
    </div>
  )
}

export default Super
